
































































































import { Component, Vue, Watch, Prop } from "vue-property-decorator";
import { Order } from "@/models/order";
import { Invoice } from "@/models/invoice";
import Pivot from "@/components/Pivot/Pivot.vue";
import loader from "@/components/loader.vue";
import api from "@/services/billing";
import accountsApi from "@/services/accounts";
import { Mutation } from "vuex-class";
import AccountCell from "@/components/cells/Account.vue";
import AccountHelpers, { Account } from "@/models/account";

@Component({
  components: {
    Pivot,
    loader,
    AccountCell
  }
})
export default class ShippingExpand extends Vue {
  @Prop() public Order?: Order;
  @Mutation("setLastErr") public setLastErr: any;

  public loading = true;
  public invoices: Invoice[] = [];

  public accountLoading = true;

  private account: Account = AccountHelpers.New();

  public async created() {
    if (!this.Order || !this.Order.id) {
      return;
    }

    try {
      this.invoices = await api.ListOrderInvoices(this.Order.id);
    } catch (e) {
      this.setLastErr(e);
    }

    try {
      this.account = await accountsApi.GetAccountByID(
        this.Order.account_id || 0
      );
      this.accountLoading = false;
    } catch (e) {
      this.setLastErr(e);
    }
    this.loading = false;
  }
}
